"use client";
import { getDefaultConfig, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { fallback, http, WagmiProvider, webSocket } from "wagmi";
import { base } from "wagmi/chains";

export const config = getDefaultConfig({
  appName: "Speedtracer",
  projectId: "df7742f6c169162f8e8c4afadb5771bf",
  chains: [base],
  ssr: true,
  transports: {
    [base.id]: fallback([
      webSocket(
        "wss://newest-intensive-tree.base-mainnet.quiknode.pro/fa9e8281c6493f04ea00818d426ee3df3525e354/"
      ),
      http(
        "https://newest-intensive-tree.base-mainnet.quiknode.pro/fa9e8281c6493f04ea00818d426ee3df3525e354/"
      ),
      http(
        "https://base-mainnet.g.alchemy.com/v2/79DjFuYv7lr7MkfA8Cm5hKGUuSHzGHbs"
      ),
      webSocket(
        "wss://base-mainnet.g.alchemy.com/v2/79DjFuYv7lr7MkfA8Cm5hKGUuSHzGHbs"
      ),
      http(
        "https://api.developer.coinbase.com/rpc/v1/base/RlYGmQ2tYB8t0PXWGV_BABDetpNwT1tG"
      ),
    ]),
  },
});

const queryClient = new QueryClient();

type Props = {
  children: React.ReactNode;
};

export const EthereumProviders = ({ children }: Props) => (
  <WagmiProvider config={config}>
    <QueryClientProvider client={queryClient}>
      <RainbowKitProvider>{children}</RainbowKitProvider>
    </QueryClientProvider>
  </WagmiProvider>
);
